// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";

interface AboutUsProps {
    agencyId: number;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId }) => {
    const { t } = useTranslation();
    const { loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;


    const LARGE_FILES_URL = import.meta.env.VITE_LARGE_FILES_BASE_URL;
    console.log("Large files url", LARGE_FILES_URL);

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.metaTitle')}</title>
                <meta name="description" content={t('aboutUsPage.metaDescription') as string }/>
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.pageTitle')} isSeo={true} />

            <main id="page" className="about-us-page">
                <section className="space-ptb">
                    <div className="container-fluid">
                        <h2 className="mb-5">{t('aboutUsPage.section1Title')}</h2>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.sectionText1') as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.sectionText2') as string }}></p>
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-10 col-xl-9 mt-3">
                                <video controls autoPlay={true}>
                                    <source src={`${LARGE_FILES_URL}/videos/ceccarelli.mp4`} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};
export default AboutUs;
